import defaultMaps from "./DefaultMaps.mp4";
import customMaps from "./CustomMaps.mp4";
import editingMapsAdvanced from "./EditingMapsAdvanced.jpg";
import resetAndRemovingMaps from "./ResetAndRemovingMaps.mp4";
import usingDrawing from "./UsingDrawing.mp4";
import openDiceTray from "./OpenDiceTray.mp4";
import diceRolling from "./DiceRolling.mp4";
import diceStyles from "./DiceStyles.mp4";
import diceTraySize from "./DiceTraySize.mp4";
import usingFog from "./UsingFog.mp4";
import usingMeasure from "./UsingMeasure.mp4";
import defaultTokens from "./DefaultTokens.mp4";
import workingWithTokens from "./WorkingWithTokens.mp4";
import deletingTokens from "./DeletingTokens.mp4";
import customTokens from "./CustomTokens.mp4";
import tokenEditor from "./TokenEditor.mp4";
import addPartyMember from "./AddPartyMember.mp4";
import changeNickname from "./ChangeNickname.mp4";
import sharingAudio from "./SharingAudio.mp4";
import startGame from "./StartGame.mp4";
import diceSharing from "./DiceSharing.mp4";
import usingTimer from "./UsingTimer.mp4";
import usingPointer from "./UsingPointer.mp4";
import mapEditor from "./MapEditor.mp4";
import filteringMaps from "./FilteringMaps.mp4";
import groupAndRemovingTokens from "./GroupAndRemovingTokens.mp4";
import filteringTokens from "./FilteringTokens.mp4";
import usingNotes from "./UsingNotes.mp4";
import settings from "./Settings.jpg";

const assets = {
  defaultMaps,
  customMaps,
  editingMapsAdvanced,
  resetAndRemovingMaps,
  usingDrawing,
  openDiceTray,
  diceRolling,
  diceStyles,
  diceTraySize,
  usingFog,
  usingMeasure,
  defaultTokens,
  workingWithTokens,
  deletingTokens,
  customTokens,
  tokenEditor,
  addPartyMember,
  changeNickname,
  sharingAudio,
  startGame,
  diceSharing,
  usingTimer,
  usingPointer,
  mapEditor,
  filteringMaps,
  groupAndRemovingTokens,
  filteringTokens,
  usingNotes,
  settings,
};

export default assets;
